import React from 'react';

export const ContactListSkeleton = () => {
    return (
        <div className="d-flex flex-column px-2">
            {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="d-flex align-items-center px-2 rounded placeholder-glow" style={{ height: '60px' }}>
                    <div className="flex-shrink-0 me-3">
                        <span className="placeholder rounded-circle" style={{ width: '40px', height: '40px', display: 'block' }}></span>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                        <h5 className="fs-13 mb-1 text-truncate">
                            <span className="placeholder col-6"></span>
                        </h5>
                        <div className="text-muted fs-12 text-truncate">
                            <span className="placeholder col-8"></span>
                        </div>
                    </div>
                    <div className="flex-shrink-0 ms-2 text-end">
                        <span className="placeholder col-12" style={{ width: '40px' }}></span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export const MessagesSkeleton = () => {
    return (
        <div className="d-flex flex-column gap-3 p-4 w-100">
            {/* Sender */}
            <div className="d-flex justify-content-end mb-4">
                <div className="placeholder-glow w-50 text-end">
                    <span className="placeholder col-12 rounded" style={{ height: '50px', backgroundColor: 'rgba(var(--vz-success-rgb), 0.2)' }}></span>
                </div>
            </div>
            
            {/* Receiver */}
            <div className="d-flex justify-content-start mb-4">
                <div className="placeholder-glow w-50">
                    <span className="placeholder col-10 rounded" style={{ height: '65px', backgroundColor: 'rgba(var(--vz-dark-rgb), 0.2)' }}></span>
                </div>
            </div>
            
            {/* Sender */}
            <div className="d-flex justify-content-end mb-4">
                <div className="placeholder-glow w-50 text-end">
                    <span className="placeholder col-8 rounded" style={{ height: '40px', backgroundColor: 'rgba(var(--vz-success-rgb), 0.2)' }}></span>
                </div>
            </div>
            
             {/* Receiver */}
             <div className="d-flex justify-content-start mb-4">
                <div className="placeholder-glow w-75">
                    <span className="placeholder col-12 rounded" style={{ height: '80px', backgroundColor: 'rgba(var(--vz-dark-rgb), 0.2)' }}></span>
                </div>
            </div>
        </div>
    );
};
